<!-- Moderne Homepage mit herausragendem Design -->

<main class="homepage">
  <!-- Hero Section mit Gradient Background -->
  <section class="hero-section" id="hero">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
          <div class="hero-text">
          <div class="hero-badge">
            <span class="badge-icon"><ion-icon name="trophy-outline" aria-hidden="true"></ion-icon></span>
            <span i18n="@@home.hero.expertiseYears">14+ Jahre Expertise</span>
          </div>
          <h1 class="hero-title" i18n>
            Ihr <span class="highlight">Zoll-Experte</span><br>
            für reibungslose<br>
            <span class="gradient-text">EU-Importe</span>
          </h1>
          <p class="hero-description" i18n="@@home.hero.description.experience">
            Wir machen Verzollung einfach. Von der ersten Beratung bis zur finalen Abwicklung – 
<strong>schnell, sicher und transparent</strong>. Vertrauen Sie auf über 14 Jahre Erfahrung
            und lassen Sie Ihre Waren problemlos in die EU einführen.
          </p>
          
          <div class="hero-stats">
            <div class="stat">
              <div class="stat-number" countUp>1000+</div>
               <div class="stat-label" i18n>Erfolgreiche Verzollungen</div>
            </div>
            <div class="stat">
              <div class="stat-number" countUp>24h</div>
               <div class="stat-label" i18n>Durchschnittliche Bearbeitungszeit</div>
            </div>
            <div class="stat">
              <div class="stat-number" countUp>99%</div>
               <div class="stat-label" i18n>Kundenzufriedenheit</div>
            </div>
          </div>

          <div class="hero-actions">
            <a href="#kontakt" class="btn-primary" (click)="scrollToContact($event)">
              <span i18n>Kostenlose Beratung</span>
              <span class="btn-icon" aria-hidden="true"><ion-icon name="chevron-forward-outline"></ion-icon></span>
            </a>
            <a href="tel:+491601254970" class="btn-secondary" i18n-aria-label="@@ariaCallNow" aria-label="Sofort anrufen: +49 160 1254970" i18n-title title="Sofort anrufen">
              <span class="phone-icon">
                <ion-icon name="call-outline" aria-hidden="true"></ion-icon>
              </span>
              <span i18n>Sofort anrufen</span>
            </a>
          </div>
        </div>
        
        <div class="hero-visual">
          <div class="hero-logo" aria-hidden="true">
            <img src="EM-Zoll Logo.png" alt="EM Zoll Logistik Logo" class="hero-logo-image" />
          </div>
          <div class="scroll-indicator" aria-hidden="true">
            <ion-icon name="chevron-down-outline" class="scroll-icon"></ion-icon>
          </div>
          <div class="contact-card" role="complementary" aria-labelledby="contact-heading">
            <header class="card-header">
              <div class="brand">
                <div class="logo">
                  <img class="logo-image" src="EM-Zoll Logo.png" alt="EM Zoll Logistik Logo" />
                </div>
                <div class="brand-info">
                  <h4 class="brand-title">EM Zoll Logistik GmbH</h4>
                  <p class="brand-subtitle" i18n>Ihr Partner für grenzüberschreitenden Handel</p>
                </div>
              </div>
            </header>
            
            <div class="card-content">
              <h3 id="contact-heading" i18n>Direkter Kontakt</h3>
              <p class="card-description" i18n>Sprechen Sie direkt mit unseren Zoll-Experten</p>
              
              <address class="contact-info">
              <div class="contact-item" itemscope itemtype="https://schema.org/PostalAddress">
                <span class="icon" aria-hidden="true">
                    <ion-icon name="location-outline"></ion-icon>
                </span>
                <div class="contact-details">
                  <strong itemprop="name">EM Zoll Logistik GmbH</strong>
                    <span class="address-line">
                      <span itemprop="streetAddress">Hartham 1</span>, 
                      <span itemprop="postalCode">94152</span> 
                      <span itemprop="addressLocality"> Neuhaus am Inn</span>
                    </span>
                  </div>
                </div>
                
              <div class="contact-item" itemscope itemtype="https://schema.org/ContactPoint">
                <span class="icon" aria-hidden="true">
                    <ion-icon name="call-outline"></ion-icon>
                </span>
                <div class="contact-details">
                  <strong>
                      <a href="tel:+491601254970" itemprop="telephone">+49 160 1254970</a>
                    </strong>
                    <span class="availability" itemprop="hoursAvailable" i18n>Mo-Fr: 6:00-22:00 Uhr<br/>Sa: 8:00-13:00 Uhr</span>
                  </div>
                </div>
              </address>
              
              <div class="card-actions">
                <a href="mailto:info@emzoll.de" class="card-cta" aria-describedby="contact-heading">
                  <span i18n>Nachricht senden</span>
                 </a>
              </div>
            </div>
          </div>
          <div class="hero-truck" aria-hidden="true" role="presentation">
             <img src="lkw.png" alt="" class="truck-image" />
             <div class="truck-ground" aria-hidden="true"></div>
           </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Trust Indicators -->
   <section class="trust-section">
     <div class="container">
       <div class="trust-content">
         <h2 i18n>Warum <span class="gradient-text">EM Zoll Logistik</span>?</h2>
         <div class="trust-grid">
            <div class="trust-item">
              <div class="trust-icon">
               <ion-icon name="flash-outline" aria-hidden="true"></ion-icon>
              </div>
              <h3 i18n>Blitzschnell</h3>
              <p i18n>Durchschnittlich 24h Bearbeitungszeit für Standardverzollungen</p>
            </div>
            <div class="trust-item">
              <div class="trust-icon">
               <ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>
              </div>
              <h3 i18n>100% Rechtssicher</h3>
              <p i18n>Vollständige Compliance mit allen EU-Zollbestimmungen</p>
            </div>
            <div class="trust-item">
              <div class="trust-icon">
               <ion-icon name="trending-down-outline" aria-hidden="true"></ion-icon>
              </div>
              <h3 i18n>Kostenoptimiert</h3>
              <p i18n>Transparente Preise ohne versteckte Kosten</p>
            </div>
            <div class="trust-item">
              <div class="trust-icon">
               <ion-icon name="construct-outline" aria-hidden="true"></ion-icon>
              </div>
              <h3 i18n>Maßgeschneidert</h3>
              <p i18n>Individuelle Lösungen für jede Warensendung</p>
            </div>
            <div class="trust-item">
              <div class="trust-icon">
               <ion-icon name="leaf-outline" aria-hidden="true"></ion-icon>
              </div>
            <h3 i18n>Umweltfreundlich</h3>
            <p i18n>Wir sind bemüht vermehrt digital zu arbeiten.</p>
           </div>
         </div>
       </div>
     </div>
   </section>



   <!-- Process Section -->
   <section class="process-section">
     <div class="container">
          <div class="section-header">
            <h2 i18n>So einfach <span class="gradient-text">geht's</span></h2>
            <p i18n>Ihr Weg zur erfolgreichen Verzollung in 4 Schritten</p>
          </div>
       
       <div class="process-timeline">
         <div class="process-step">
           <div class="step-icon"><ion-icon name="document-text-outline" aria-hidden="true"></ion-icon></div>
           <div class="step-number">1</div>
           <div class="step-content">
             <h3 i18n>Anfrage stellen</h3>
             <p i18n>Senden Sie uns Ihre Warendaten und Dokumente. Wir erstellen Ihnen ein transparentes Angebot.</p>
           </div>
         </div>
         
         <div class="process-step">
           <div class="step-icon"><ion-icon name="clipboard-outline" aria-hidden="true"></ion-icon></div>
           <div class="step-number">2</div>
           <div class="step-content">
             <h3 i18n>Prüfung & Vorbereitung</h3>
             <p i18n>Wir prüfen alle Dokumente und bereiten die Zollanmeldung vor. Sie erhalten eine Bestätigung.</p>
           </div>
         </div>
         
         <div class="process-step">
           <div class="step-icon"><ion-icon name="receipt-outline" aria-hidden="true"></ion-icon></div>
           <div class="step-number">3</div>
           <div class="step-content">
             <h3 i18n>Verzollung</h3>
             <p i18n>Elektronische Anmeldung beim Zoll und Abwicklung aller erforderlichen Formalitäten.</p>
           </div>
         </div>
         
         <div class="process-step">
           <div class="step-icon"><ion-icon name="checkmark-done-outline" aria-hidden="true"></ion-icon></div>
           <div class="step-number">4</div>
           <div class="step-content">
             <h3 i18n>Freigabe & Abrechnung</h3>
             <p i18n>Nach erfolgreicher Verzollung erhalten Sie alle Dokumente und eine detaillierte Abrechnung.</p>
           </div>
         </div>
       </div>
     </div>
   </section>

   <!-- CTA Section -->
   <section class="cta-section">
     <div class="container">
       <div class="cta-content">
         <div class="cta-text">
           <h2 i18n>Bereit für Ihre nächste Verzollung?</h2>
           <p i18n>Lassen Sie uns Ihre Wareneinfuhr professionell abwickeln. Kontaktieren Sie uns für ein unverbindliches Angebot.</p>
         </div>
         <div class="cta-actions">
           <a href="mailto:info@emzoll.de" class="btn-primary large">
            <span i18n>Jetzt Angebot anfordern</span>
            <span class="btn-icon">→</span>
          </a>
           <div class="cta-contact">
             <span i18n>Oder direkt anrufen:</span>
             <a href="tel:+491601254970" class="phone-link">+49 160 1254970</a>
           </div>
         </div>
       </div>
     </div>
   </section>

  <!-- About Section -->
  <section class="about-section" id="ueber-uns">
    <div class="about-background">
      <div class="floating-elements">
        <div class="floating-shape shape-1"></div>
        <div class="floating-shape shape-2"></div>
        <div class="floating-shape shape-3"></div>
      </div>
    </div>
    
    <div class="container">
      <div class="about-content">
        <div class="about-text">
          <div class="section-header">
            <div class="section-badge">
              <span class="badge-icon"><ion-icon name="location-outline" aria-hidden="true"></ion-icon></span>
              <span i18n>Neuhaus am Inn, Bayern</span>
            </div>
            <h2 i18n>Über <span class="gradient-text">EM Zoll Logistik</span></h2>
            <p class="section-subtitle" i18n="@@home.about.subtitle.partner">Ihr vertrauensvoller Partner seit über 14 Jahren</p>
          </div>
          
          <div class="about-description">
            <div class="highlight-text">
              <span class="highlight-icon"><ion-icon name="star-outline" aria-hidden="true"></ion-icon></span>
            <p i18n="@@home.about.experienceText"><strong>EM Zoll Logistik GmbH</strong> ist ein erfahrenes Team mit mehr als 14 Jahren Branchenerfahrung in allen Bereichen der zollrechtlichen Abwicklung.</p>
            </div>
            
            <p i18n>Wir unterstützen Unternehmen und Privatpersonen dabei, Waren aus Drittstaaten korrekt und wirtschaftlich in die EU zu bringen. Unsere Stärke ist eine lösungsorientierte Arbeitsweise: Wir finden für nahezu jede Herausforderung einen praktikablen Weg.</p>
          </div>
          
          <div class="expertise-grid">
            <div class="expertise-item">
              <div class="expertise-icon"><ion-icon name="layers-outline" aria-hidden="true"></ion-icon></div>
              <div class="expertise-content">
                <h4 i18n>Warentarifierung</h4>
                <p i18n>Präzise Klassifizierung für optimale Zollabwicklung</p>
              </div>
            </div>
            
            <div class="expertise-item">
              <div class="expertise-icon"><ion-icon name="trending-down-outline" aria-hidden="true"></ion-icon></div>
              <div class="expertise-content">
                <h4 i18n>Kostenoptimierung</h4>
                <p i18n>Kostenoptimierung durch Ihre Unterstützung – wir machen Ihr Zollverfahren einfacher und günstiger</p>
              </div>
            </div>
          </div>
          
          <div class="mission-box">
            <div class="mission-header">
              <div class="mission-icon"><ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon></div>
              <h3 i18n>Unsere Mission</h3>
            </div>
            <p i18n>Rechtssicher, effizient und transparent — damit Ihre Lieferung ohne Verzögerung ans Ziel kommt.</p>
            <div class="mission-values">
              <span class="value-tag" i18n>Rechtssicher</span>
              <span class="value-tag" i18n>Effizient</span>
              <span class="value-tag" i18n>Transparent</span>
            </div>
          </div>
        </div>
        
        <div class="about-visual">
          <div class="stats-container">
            <div class="experience-card main-stat">
              <div class="stat-icon"><ion-icon name="ribbon-outline" aria-hidden="true"></ion-icon></div>
              <div class="experience-number" countUp>14+</div>
              <div class="experience-label" i18n>Jahre Erfahrung</div>
              <div class="experience-description">
                <span i18n>Bewährte Expertise in der Zollabwicklung für alle Warengruppen</span>
              </div>
            </div>
            
            <div class="secondary-stats">
              <div class="secondary-stat">
                <div class="secondary-number" countUp>1000+</div>
                <div class="secondary-label" i18n>Verzollungen</div>
              </div>
              <div class="secondary-stat">
                <div class="secondary-number" countUp>24h</div>
                <div class="secondary-label" i18n>Ø Bearbeitung</div>
              </div>
            </div>
          </div>
          
          <div class="company-info-card">
            <div class="company-header">
              <div class="company-logo">
                <img src="EM-Zoll Logo.png" alt="EM Zoll Logistik Logo" />
              </div>
              <div class="company-details">
                <h4>EM Zoll Logistik GmbH</h4>
                <p>Hartham 1, 94152 Neuhaus am Inn</p>
              </div>
            </div>
            <div class="company-contact">
              <a href="tel:+491601254970" class="contact-button">
                <span class="contact-icon" aria-hidden="true"><ion-icon name="call-outline"></ion-icon></span>
                <span>+49 160 1254970</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Services Section -->
  <section class="detailed-services-section" id="dienstleistungen">
    <div class="container">
      <div class="section-header">
        <h2 i18n>Unsere <span class="gradient-text">Dienstleistungen</span></h2>
        <p i18n>Umfassende Zollabwicklung für alle Ihre Anforderungen</p>
      </div>
      
      <div class="detailed-services-grid">
        <div class="detailed-service-card">
          <div class="service-number">1</div>
          <div class="service-content">
            <h3 i18n="@@home.services.import.title">Importverzollungen DE</h3>
            <p i18n="@@home.services.import.desc">Wir übernehmen die komplette Verzollung in Deutschland — für Firmen und Privatpersonen.</p>
            <div class="service-details">
              <div class="detail-item">
                <span class="detail-icon"><ion-icon name="business-outline" aria-hidden="true"></ion-icon></span>
                <div>
                  <strong i18n="@@home.services.import.business.title">Importverzollung für Firmen</strong>
                  <p i18n="@@home.services.import.business.desc">Komplettservice inkl. Dokumentenprüfung, Tarifierung und Abwicklung.</p>
                </div>
              </div>
              <div class="detail-item">
                <span class="detail-icon"><ion-icon name="person-outline" aria-hidden="true"></ion-icon></span>
                <div>
                  <strong i18n="@@home.services.import.private.title">Importverzollung für Privatpersonen</strong>
                  <p i18n="@@home.services.import.private.desc">Unabhängig vom EU-Herkunftsland: In Deutschland fällt 19% Einfuhrmsatzsteuer an; eine doppelte Verzollung im Heimatland entfällt in der Regel.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="detailed-service-card">
          <div class="service-number">2</div>
          <div class="service-content">
            <h3 i18n="@@home.services.fiscal.title">Fiskalverzollungen (EU, außer Deutschland)</h3>
            <p i18n="@@home.services.fiscal.desc">Fiskalverzollung ermöglicht es, die Steuerzahlung nicht direkt bei der Verzollung zu leisten, sondern diese über die reguläre Vorsteueranmeldung beim lokalen Finanzamt abzuwickeln. Wir organisieren die Fiskalvertretung und Abwicklung für alle EU-Länder außer Deutschland.</p>
          </div>
        </div>

        <div class="detailed-service-card">
          <div class="service-number">3</div>
          <div class="service-content">
            <h3 i18n="@@home.services.food.title">Lebensmittelverzollungen</h3>
            <p i18n="@@home.services.food.desc">Besondere Anforderungen und Kontrollen bei Lebensmitteln übernehmen wir fachgerecht — für Frischwaren, Tiefkühlgut, Fisch und viele weitere Produktgruppen.</p>
            <div class="food-categories">
              <div class="food-category">
                <span class="category-icon"><ion-icon name="leaf-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.food.fresh">Frischgut (Obst, Gemüse, verderbliche Frischwaren)</span>
              </div>
              <div class="food-category">
                <span class="category-icon"><ion-icon name="cube-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.food.frozen">Tiefkühlware</span>
              </div>
              <div class="food-category">
                <span class="category-icon"><ion-icon name="fish-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.food.fish">Fisch & Meeresfrüchte</span>
              </div>
              <div class="food-category">
                <span class="category-icon"><ion-icon name="cafe-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.food.examples">Weitere Beispiele: Teigwaren, Weizen, Nudeln, Kaffee, Schokolade, Getränke u.ä.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="detailed-service-card">
          <div class="service-number">4</div>
          <div class="service-content">
            <h3 i18n="@@home.services.consult.title">Zollberatung</h3>
            <p i18n="@@home.services.consult.desc">Unsere Beratung umfasst Tarifierung, Außenwirtschaftsrecht, Präferenzen, Ursprungsregeln sowie Prozessoptimierung zur Reduzierung von Zeit- und Kostenaufwand.</p>
            <div class="consultation-areas">
              <span class="area-tag" i18n="@@home.services.consult.tariff">Tarifierung</span>
              <span class="area-tag" i18n="@@home.services.consult.foreigntrade">Außenwirtschaftsrecht</span>
              <span class="area-tag" i18n="@@home.services.consult.preferences">Präferenzen</span>
              <span class="area-tag" i18n="@@home.services.consult.originrules">Ursprungsregeln</span>
              <span class="area-tag" i18n="@@home.services.consult.processopt">Prozessoptimierung</span>
            </div>
          </div>
        </div>

        <div class="detailed-service-card">
          <div class="service-number">5</div>
          <div class="service-content">
            <h3 i18n="@@home.services.export.title">Exportabfertigungen</h3>
            <p i18n="@@home.services.export.desc">Professionelle Abwicklung aller Exportverfahren.</p>
            <div class="export-types">
              <div class="export-type">
                <span class="type-icon"><ion-icon name="document-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.export.types.exportdeclaration">Ausfuhranmeldung</span>
              </div>
              <div class="export-type">
                <span class="type-icon"><ion-icon name="cube-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.export.types.t1">T1</span>
              </div>
              <div class="export-type">
                <span class="type-icon"><ion-icon name="cube-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.export.types.t2">T2</span>
              </div>
              <div class="export-type">
                <span class="type-icon"><ion-icon name="cube-outline" aria-hidden="true"></ion-icon></span>
                <span i18n="@@home.services.export.types.tdash">T-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Resources Section -->
  <section class="resources-section" id="links">
    <div class="container">
      <div class="section-header">
        <h2 i18n>Hilfreiche <span class="gradient-text">Ressourcen</span></h2>
        <p i18n>Wichtige Links für Zoll und Außenhandel</p>
      </div>
      
      <div class="resources-grid">
        <a href="https://ec.europa.eu/taxation_customs/dds2/taric/taric_consultation.jsp?Lang=de" target="_blank" rel="noopener" class="resource-card">
          <div class="resource-icon" aria-hidden="true"><ion-icon name="globe-outline"></ion-icon></div>
          <div class="resource-content">
            <h3>EU TARIC</h3>
            <p i18n>Taric-Abfragen für EU-Zolltarife</p>
            <span class="resource-link" i18n>Zur Website →</span>
          </div>
        </a>
        
        <a href="https://www.zoll.de/DE/Startseite/start_node.html" target="_blank" rel="noopener" class="resource-card">
          <div class="resource-icon" aria-hidden="true"><ion-icon name="flag-outline"></ion-icon></div>
          <div class="resource-content">
            <h3>Zoll.de</h3>
            <p i18n>Offizieller deutscher Zoll</p>
            <span class="resource-link" i18n>Zur Website →</span>
          </div>
        </a>
        
        <a href="https://www.zoll-eso.de/" target="_blank" rel="noopener" class="resource-card">
          <div class="resource-icon" aria-hidden="true"><ion-icon name="laptop-outline"></ion-icon></div>
          <div class="resource-content">
            <h3>EZT Online</h3>
            <p i18n>Internet-Zolltarif Deutschland</p>
            <span class="resource-link" i18n>Zur Website →</span>
          </div>
        </a>
        
        <a href="https://ec.europa.eu/taxation_customs/dds2/eos/eos_consultation.jsp" target="_blank" rel="noopener" class="resource-card">
          <div class="resource-icon" aria-hidden="true"><ion-icon name="search-outline"></ion-icon></div>
          <div class="resource-content">
            <h3>EZT / EOS EU</h3>
            <p i18n>EU Zolldienste und Tools</p>
            <span class="resource-link" i18n>Zur Website →</span>
          </div>
        </a>
      </div>
    </div>
  </section>

  <!-- Contact Form Section -->
  <section class="contact-form-section" id="kontakt">
    <div class="container">
      <div class="contact-form-content">
        <div class="contact-form-header">
          <h2 i18n>Kontaktieren Sie uns</h2>
          <p i18n="@@home.contact.info.intro">Sie erreichen uns über die folgenden Kontaktwege.</p>
        </div>
        
        <div class="contact-form-wrapper">
          <div class="contact-info-box">
            <h4 i18n>Kontaktinformationen</h4>
            <div class="contact-details">
              <div class="contact-detail">
                <ion-icon name="business-outline" class="detail-icon" aria-hidden="true"></ion-icon>
                <div>
                  <strong>EM Zoll Logistik GmbH</strong><br>
                  Hartham 1, 94152 Neuhaus am Inn
                </div>
              </div>
              <div class="contact-detail">
                <ion-icon name="call-outline" class="detail-icon" aria-hidden="true"></ion-icon>
                <div>
                  <strong><a href="tel:+491601254970">+49 160 1254970</a></strong><br>
                  <span i18n>Mo-Fr: 6:00-22:00 Uhr<br/>Sa: 8:00-13:00 Uhr</span>
                </div>
              </div>
              <div class="contact-detail">
                <ion-icon name="mail-outline" class="detail-icon" aria-hidden="true"></ion-icon>
                <div>
                  <strong><a href="mailto:info@emzoll.de">info@emzoll.de</a></strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</main>